import React, { useState, useEffect, useRef } from 'react';
import { Validaciones } from '@renedelangel/helpers';
import Tabla from '../../../../_layout/masterComponents/Tabla';
import { primary } from '_layout/helpers/colores';
import ArchiveIcon from '@material-ui/icons/Archive';
import SyncIcon from '@material-ui/icons/Sync';
import Edit from '@material-ui/icons/Edit';
import Close from '@material-ui/icons/Close';
import Add from '@material-ui/icons/Add';
import SaveIcon from '@material-ui/icons/Save';
import { danger, info } from '_layout/helpers/colores';
import { success } from '_layout/helpers/colores';
import FormularioModal from '_layout/masterComponents/FormularioModal';
import { handleFocus, handleErrorInputText, handleModificar, handelAlertEliminar, handleEliminar, handleGuardar, handleAlertGeneric, handleAlertMutationGeneric } from '../../../../_layout/helpers/handles';
import { useSelector } from 'react-redux';
import * as Consultas from './Consultas.js'
const { trim } = Validaciones;

export default function VersionesMoviles() {
const rgxNumeros = /^[0-9]+([.][0-9])+([.][0-9])?$/;
const rgxLetras = /[A-Za-z]{6,30}$/;

    const cleanState = {
        versionID: '',
        nombreApp: '',
        claveApp: '',
        plataforma: '',
        version: '',
        mensaje: '',
        fechaAlta: new Date().toISOString().split('T')[0],
        fechaUltimaVersion: new Date().toISOString().split('T')[0],
    }

    const cleanErrorState = {
        versionID: { error: false, helperText: "" },
        nombreApp: { error: false, helperText: "" },
        claveApp: { error: false, helperText: "" },
        plataforma: { error: false, helperText: "" },
        version: { error: false, helperText: "" },
        mensaje: { error: false, helperText: "" },
        fechaAlta: { error: false, helperText: "" },
        fechaUltimaVersion: { error: false, helperText: "" }
    }

    const cleanNotificaciones = { mensaje: "", color: null, open: false };

    const { token } = useSelector(state => state.login);
    const [actualizar, setActualizar] = useState(false);
    const [state, setState] = useState(cleanState)
    const [open, setOpen] = useState(false);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState(null);
    const [loader, setLoader] = useState(false);

    const versionIDRef = useRef(null);
    const nombreAppRef = useRef(null);
    const claveAppRef = useRef(null);
    const plataformaRef = useRef(null);
    const versionRef = useRef(null);
    const mensajeRef = useRef(null);
    const fechaAltaRef = useRef(null);
    const fechaUltimaVersionRef = useRef(null);


    let titleAccion = state.versionID ? "Modificar" : "Agregar";
    let titleModal = `${titleAccion} información de la versión`;

    const acciones = [
        {
            icono: Edit,
            color: info,
            descripcion: "Modificar",
            id: "Modificar",
            parametros: [{
                campo: "versionID",
            }],
            disabled: { multiseleccion: true },
            onClick: (parametros) => {

                handleModificar({
                    parametros, token, setState, setOpen, setAlert,
                    asyncGet: Consultas.getVersionMovil,
                    formatearResultado: [
                        { id: "fechaAlta", formato: (data) => new Date(data).toISOString().split('T')[0] },
                        { id: "fechaUltimaVersion", formato: (data) => new Date(data).toISOString().split('T')[0] },
                    ]
                })
            }
        },
    ]


    const botones = [
        {
            icono: Add,
            color: success,
            descripcion: "Agregar",
            onClick: () => setOpen(true),
            disabled: { multiseleccion: true }
        },
        {
            icono: SyncIcon,
            color: info,
            descripcion: "Actualizar",
            onClick: () => setActualizar(!actualizar),
            disabled: { multiseleccion: true }
        }
    ]


    const inputs = [
        {
            disabled,
            id: "nombreApp",
            value: state.nombreApp,
            error: errorState.nombreApp.error,
            success: state.nombreApp && !errorState.nombreApp.error ? true : undefined,
            helperText: errorState.nombreApp.helperText,
            inputRef: nombreAppRef,
            title: "Nombre Aplicación",
            grid: { md: 4, sm: 4, lg: 4 },
            placeholder: "Capture el nombre de la aplicación",
            onChange: ({ target: { value } }) => { setState({ ...state, nombreApp: value }) },
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "claveApp",
            value: state.claveApp,
            error: errorState.claveApp.error,
            success: state.claveApp && !errorState.claveApp.error ? true : undefined,
            helperText: errorState.claveApp.helperText,
            inputRef: claveAppRef,
            grid: { md: 4, sm: 4, lg: 4 },
            title: "Clave Aplicación",
            placeholder: "Capture la clave de la aplicación",
            onChange: ({ target: { value } }) => handleChange(value, "claveApp"),
            onKeyDown: () => { return; }
        },
        // {
        //     disabled,
        //     id: "plataforma",
        //     value: state.plataforma,
        //     error: errorState.plataforma.error,
        //     success: state.plataforma && !errorState.plataforma.error ? true : undefined,
        //     helperText: errorState.plataforma.helperText,
        //     inputRef: plataformaRef,
        //     grid: { md: 6, sm: 6, lg: 6 },
        //     title: "plataforma",
        //     placeholder: "Capture la plataforma de la aplicación",
        //     onChange: ({ target: { value } }) => handleChange(value, "plataforma"),
        //     onKeyDown: () => { return; }
        // },
        {
            disabled,
            id: "version",
            value: state.version,
            error: errorState.version.error,
            success: state.version && !errorState.version.error ? true : undefined,
            helperText: errorState.version.helperText,
            inputRef: versionRef,
            grid: { md: 4, sm: 4, lg: 4 },
            title: "Versión",
            placeholder: "Capture la versión",
            onChange: ({ target: { value } }) => handleChange(value, "version"),
            onKeyDown: () => { return; }
        },
        {
            disabled: true,
            id: "fechaAlta",
            value: state.fechaAlta,
            error: errorState.fechaAlta.error,
            success: state.fechaAlta && !errorState.fechaAlta.error ? true : undefined,
            helperText: errorState.fechaAlta.helperText,
            inputRef: fechaAltaRef,
            grid: { md: 6, sm: 6, lg: 6 },
            title: "Fecha de Alta",
            placeholder: "Fecha de Alta",
        },
        {
            disabled: true,
            id: "fechaUltimaVersion",
            value: state.fechaUltimaVersion,
            error: errorState.fechaUltimaVersion.error,
            success: state.fechaUltimaVersion && !errorState.fechaUltimaVersion.error ? true : undefined,
            helperText: errorState.fechaUltimaVersion.helperText,
            inputRef: fechaUltimaVersionRef,
            grid: { md: 6, sm: 6, lg: 6 },
            title: "Fecha Última Versión",
            placeholder: "Fecha Última Versión",
        },

    ]


    const infoTabla = {
        id: "versionID",
        color: primary,
        title: "Alta de Versiones Móviles",
        iconTable: <ArchiveIcon />,
        actualizar,
        acciones,
        botones,
        headers: [
            { variable: "versionID", descripcion: "versionID", hide: true },
            { variable: "nombreApp", descripcion: "Aplicación", hide: false },
            { variable: "claveApp", descripcion: "Clave", hide: false },
            { variable: "plataforma", descripcion: "Plataforma", hide: true },
            { variable: "version", descripcion: "Versión", hide: false },
            { variable: "mensaje", descripcion: "Mensaje", hide: true }
        ],
        responsiveTitle: ["nombreApp", "version"]
    }

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState, condicion, ref, keyError, mensajeError,
            loader: setLoader, disabled: setDisabled, errorState: setErrorState
        });
    }

    function handleClose() {
        setOpen(false);
        setDisabled(false);
        setLoader(false);
        setNotificaciones({ ...cleanNotificaciones });
        setState({ ...cleanState });
        setErrorState({ ...cleanErrorState });
    }

    let accionesFormulario = [{
        loader,
        disabled,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => handleGuardar({
            setLoader,
            setDisabled,
            setActualizar,
            actualizar,
            setNotificaciones,
            handleClose,
            handleFocus,
            refFocus: nombreAppRef,
            mensajeCorrecto: `El registro se ${state.versionID ? "actualizó" : "agregó"} correctamente`,
            asyncCallback: ftGuardar,
        }),

    },
    {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleClose
    }
    ]

    function handleValidaciones({
        nombreApp,
        claveApp,
        version,
    }) {
        let error;

        let validaciones = [
            {
                condicion: !nombreApp || trim(nombreApp) === "",
                ref: nombreAppRef, keyError: "nombreApp",
                mensajeError: "Debe especificar el nombre"
            },
            {
                condicion: !claveApp || trim(claveApp) === "" || !rgxLetras.test(claveApp),
                ref: claveAppRef, keyError: "claveApp",
                mensajeError: "Especificar una clave valida. Ej: erpsign"
            },
            {
                condicion: !version || trim(version) === "" || !rgxNumeros.test(version),
                ref: versionRef, keyError: "version",
                mensajeError: "Especificar una versión valida. Ej: 1.1"
            },
        ];
        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
        });

        if (error) return error;

    }

    function handleChange(value, key) { setState({ ...state, [key]: value }); }

    function ftGuardar() {
        async function ftGuardar() {
            let {
                versionID,
                nombreApp,
                claveApp,
                plataforma,
                version,
                mensaje
            } = state;

            let error = await handleValidaciones({
                nombreApp,
                claveApp,
                version,
            })
            if (error) return error;

            if(versionID) await Consultas.updateVersionMovil({
                input:{
                    versionID,
                    nombreApp,
                    claveApp,
                    plataforma,
                    version,
                    mensaje
                }
            }, token);
            else await Consultas.addVersionMovil({
                input:{
                    nombreApp,
                    claveApp,
                    plataforma,
                    version,
                    mensaje
                }
            }, token)
        }
        return ftGuardar();
    }

    return (<>

        <Tabla
            infoTabla={infoTabla}
            asyncData={Consultas.tablaVersionesMoviles}
            token={token}
        />

        <FormularioModal
            open={open}
            title={titleModal}
            onClose={handleClose}
            notificaciones={notificaciones}
            closeNotificaciones={() => setNotificaciones({
                ...cleanNotificaciones
            })}
            inputs={inputs}
            acciones={accionesFormulario}
            focus={nombreAppRef}
        />
    </>)
}